import React from 'react'
import { TotalsCart } from 'components/Cart/components/TotalsCart'
import { Container } from './components/Styled'

export const Totals = () => {
  return (
    <Container>
      <p
        className='cart__heading'
      >
        <span>Subtotal</span>
      </p>
      <TotalsCart />
    </Container>
  )
}
